// extracted by mini-css-extract-plugin
export var first = "Header-module--first--e9768";
export var header = "Header-module--header--d1136";
export var labSymbol = "Header-module--lab-symbol--82b8f";
export var last = "Header-module--last--c2b2b";